import { UserStatus } from '@utilities-one/api-sdk';

import { SemanticColor } from '@/config/colors';

export const userStatusNames = {
  [UserStatus.active]: 'Active',
  [UserStatus.inactive]: 'Inactive',
  [UserStatus.pending]: 'Pending',
};

const userStatusColors: Record<UserStatus, SemanticColor> = {
  [UserStatus.active]: SemanticColor.success,
  [UserStatus.inactive]: SemanticColor.danger,
  [UserStatus.pending]: SemanticColor.warning,
};

export const userStatus = (status: UserStatus): { name: string; color: SemanticColor } => ({
  name: userStatusNames[status],
  color: userStatusColors[status],
});

export const EMOTIONS_MAP = [
  { key: 'optimistic', label: 'Optimistic', color: '#1FC8EA' },
  { key: 'motivated', label: 'Motivated', color: '#551199' },
  { key: 'proud', label: 'Proud', color: '#EAC51F' },
  { key: 'focused', label: 'Focused', color: '#EA811F' },
  { key: 'busy', label: 'Busy', color: '#EA1F1F' },
];

export const SYSTEM_USER = {
  email: 'system@u1.com',
  name: 'System',
  id: 'system',
};

export const SYSTEM_ADMIN_USER_ID = 'system_admin';
